<script lang="ts" setup>
import { AppButton, AppTextField } from '#core/components';
import { computed } from 'vue';

const emits = defineEmits<{
  (e: 'next', username: string): void;
}>();

const { form, serverError, loadingForgotPassword, handleForgotPassword, getErrors } = useForgotPassword();

function forgotPassword() {
  handleForgotPassword(function() {
    emits('next', form.value.username);
  });
}

const errors = computed(() => {
  return getErrors({ username: serverError.value?.data?.errors.username });
});

const canContinue = computed(() => {
  return form.value.username.trim() !== '' && !loadingForgotPassword.value;
});
</script>

<template>
  <v-form @submit.prevent="forgotPassword">
    <AppTextField
      v-model="form.username"
      data-testid="email"
      label="Email Address"
      :error-messages="errors.username"
      :disabled="loadingForgotPassword"
      autofocus
      class="w-full"
      data-cy="input-email"
    >
    </AppTextField>

    <AppButton
      type="submit"
      block
      class="btn-continue"
      :loading="loadingForgotPassword"
      :disabled="!canContinue"
      data-testid="submit"
    >
      Continue
    </AppButton>
  </v-form>
</template>

<style lang="scss" scoped>
.v-card {
  margin-top: 132px;
}

</style>
